module.exports = __webpack_public_path__ + "static/media/poikiliasm_full2.5b3af187.jpg";